import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { InsightsRoute } from "./insight.routes";

export function Insights() {
  return (
    <Layout>
      {InsightsRoute.subRoutes && (
        <ModuleRouter subRoutes={InsightsRoute.subRoutes} path={InsightsRoute.path} />
      )}
    </Layout>
  );
}
